import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=1c9450e0&scoped=true&"
import script from "./Roles.vue?vue&type=script&lang=js&"
export * from "./Roles.vue?vue&type=script&lang=js&"
import style0 from "./Roles.vue?vue&type=style&index=0&id=1c9450e0&prod&scoped=true&lang=css&"
import style1 from "./style.css?vue&type=style&index=1&id=1c9450e0&prod&scoped=true&lang=css&"
import style2 from "./Roles.vue?vue&type=style&index=2&id=1c9450e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9450e0",
  null
  
)

export default component.exports